import { render, staticRenderFns } from "./study-participant-configure-document.vue?vue&type=template&id=53498cb0&scoped=true&"
import script from "./study-participant-configure-document.vue?vue&type=script&lang=js&"
export * from "./study-participant-configure-document.vue?vue&type=script&lang=js&"
import style0 from "@/assets/dot-streaching-loader.scss?vue&type=style&index=0&id=53498cb0&scoped=true&lang=scss&"
import style1 from "../../../public/static/fonts.scss?vue&type=style&index=1&id=53498cb0&scoped=true&lang=scss&"
import style2 from "./study-participant-configure-document.vue?vue&type=style&index=2&id=53498cb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53498cb0",
  null
  
)

component.options.__file = "study-participant-configure-document.vue"
export default component.exports